import React from "react";
import { AppUtils } from "../../utils/AppUtils";
import './ImageViewer.css';
import $ from 'jquery';
import CloseMenuIcon from "../../resources/wrappers/menu/CloseMenuIcon";
import Media from "react-media";

export class ImageViewer extends React.Component<any, any> {
    constructor(props: any){
        super(props);
        this.state = {
            imageViewDesktop: '',
            imageViewMobile: ''
        }
    }

    componentDidMount(){
        window.scrollTo(0, 0);
        console.log("[ImageViewer] did mount");
        if(!AppUtils.isPhoneOrTablet()){
            // Hide footer
            $("#desktop-footer-body").hide();
        }

        let mainHeight = $('#app-parent').height()!!;
        $('#image-viewer-main').height(mainHeight);

        this.resizeImageDesktop(this.props.imageSrc);
        this.resizeImageMobile(this.props.imageSrc);
    }

    resizeImageDesktop(imageSrc: any) {
        var img = new Image;
        img.onload = () => {
            var newWidth, newHeight, canvas, ctx;
            newWidth = 600;
            newHeight = 600;
            canvas = document.createElement('canvas');
            canvas.height = newHeight;
            canvas.width = newWidth;
            ctx = canvas.getContext('2d');
            //@ts-ignore
            ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight);
            this.setState({imageViewDesktop: canvas.toDataURL()});
        };
        img.src = imageSrc;
    }

    resizeImageMobile(imageSrc: any) {
        var img = new Image;
        let windowWidth = window.outerWidth - 30;
        img.onload = () => {
            var newWidth, newHeight, canvas, ctx;
            newWidth = windowWidth;
            newHeight = windowWidth;
            canvas = document.createElement('canvas');
            canvas.height = newHeight;
            canvas.width = newWidth;
            ctx = canvas.getContext('2d');
            //@ts-ignore
            ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight);
            this.setState({imageViewMobile: canvas.toDataURL()});
        };
        img.src = imageSrc;
    }

    render() {
        return <div id={"image-viewer-main"} className={this.props.fullScreen ? "image-viewer-main fullscreen" : "image-viewer-main"}>
            <div className={"image-viewer-container"}>
                <div className={"image-viewer-container-close"} onClick={() => this.props.closeFunction()}>
                    <CloseMenuIcon width={'20px'} height={'20px'} fill={'#FFFFFF'} />
                </div>
                <div>
                    {[
                        <Media  query="(min-width: 1065px)" render={() => {
                            return <img src={this.state.imageViewDesktop} />
                        }}/>,
                        <Media  query="(max-width: 1064px)" render={() => {
                            return <img src={this.state.imageViewMobile} />
                        }}/>
                    ]}
                    
                </div>
            </div>
        </div>
    }
}